import { render, staticRenderFns } from "./carouselBanner.vue?vue&type=template&id=006af0be&"
import script from "./carouselBanner.vue?vue&type=script&lang=js&"
export * from "./carouselBanner.vue?vue&type=script&lang=js&"
import style0 from "./carouselBanner.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports